import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 14,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9"}`,
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    overflow: "hidden",
  },
  head: {
    backgroundColor: theme.palette.type === "dark" ? "#1E293B" : "#F8FAFC",
  },
  headCell: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontWeight: 600,
    fontSize: 12,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    borderBottom: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#E2E8F0"}`,
    padding: "12px 16px",
  },
  row: {
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "#F8FAFC",
    },
    "&:last-child td": {
      borderBottom: "none",
    },
  },
  cell: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.type === "dark" ? "#E2E8F0" : "#334155",
    borderBottom: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#F1F5F9"}`,
    padding: "10px 16px",
  },
  nameCell: {
    fontWeight: 600,
    color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
  },
  chipOnline: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 11,
    fontWeight: 600,
    height: 24,
    borderRadius: 6,
    backgroundColor: "rgba(16, 185, 129, 0.1)",
    color: "#10B981",
  },
  chipOffline: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 11,
    fontWeight: 600,
    height: 24,
    borderRadius: 6,
    backgroundColor: "rgba(239, 68, 68, 0.1)",
    color: "#EF4444",
  },
  skeleton: {
    borderRadius: 14,
  },
}));

export function RatingBox({ rating }) {
  const ratingTrunc = rating === null ? 0 : Math.trunc(rating);
  return ratingTrunc;
}

export default function TableAttendantsStatus(props) {
  const { loading, attendants } = props;
  const classes = useStyles();

  function renderList() {
    return attendants.map((a, k) => (
      <TableRow key={k} className={classes.row}>
        <TableCell className={`${classes.cell} ${classes.nameCell}`}>
          {a.name}
        </TableCell>
        <TableCell align="center" className={classes.cell}>
          {a.rating}
        </TableCell>
        <TableCell align="center" className={classes.cell}>
          {a.countRating}
        </TableCell>
        <TableCell align="center" className={classes.cell}>
          {a.tickets}
        </TableCell>
        <TableCell align="center" className={classes.cell}>
          {a.ticketsCurrentMonth != null ? a.ticketsCurrentMonth : 0}
        </TableCell>
        <TableCell align="center" className={classes.cell}>
          {formatTime(a.avgWaitTime)}
        </TableCell>
        <TableCell align="center" className={classes.cell}>
          {formatTime(a.avgSupportTime)}
        </TableCell>
        <TableCell align="center" className={classes.cell}>
          {a.online ? (
            <Tooltip title="Online">
              <Chip label="Online" className={classes.chipOnline} size="small" />
            </Tooltip>
          ) : (
            <Tooltip title="Offline">
              <Chip label="Offline" className={classes.chipOffline} size="small" />
            </Tooltip>
          )}
        </TableCell>
      </TableRow>
    ));
  }

  function formatTime(minutes) {
    return moment()
      .startOf("day")
      .add(minutes, "minutes")
      .format("HH[h] mm[m]");
  }

  return !loading ? (
    <TableContainer component={Paper} className={classes.container} elevation={0}>
      <Table>
        <TableHead className={classes.head}>
          <TableRow>
            <TableCell className={classes.headCell}>
              {i18n.t("dashboard.users.name")}
            </TableCell>
            <TableCell align="center" className={classes.headCell}>
              {i18n.t("dashboard.assessments.score")}
            </TableCell>
            <TableCell align="center" className={classes.headCell}>
              {i18n.t("dashboard.assessments.ratedCalls")}
            </TableCell>
            <TableCell align="center" className={classes.headCell}>
              Atendimentos (período)
            </TableCell>
            <TableCell align="center" className={classes.headCell}>
              Atendimentos (mês atual)
            </TableCell>
            <TableCell align="center" className={classes.headCell}>
              {i18n.t("dashboard.cards.averageWaitingTime")}
            </TableCell>
            <TableCell align="center" className={classes.headCell}>
              {i18n.t("dashboard.cards.averageServiceTime")}
            </TableCell>
            <TableCell align="center" className={classes.headCell}>
              {i18n.t("dashboard.cards.status")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderList()}</TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Skeleton variant="rect" height={150} className={classes.skeleton} />
  );
}
